import { startErrorReporter } from "@kaggle/components";
import { bootstrapJupyterLabSessionlessEditor } from "./bootstrapJupyterLabSessionlessEditor";

startErrorReporter(/* versionModifier= */ "sessionless");
bootstrapJupyterLabSessionlessEditor();
